import { render, staticRenderFns } from "./SalesDocumentsPage.vue?vue&type=template&id=1d6d31fc&scoped=true"
import script from "./SalesDocumentsPage.vue?vue&type=script&lang=js"
export * from "./SalesDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./SalesDocumentsPage.vue?vue&type=style&index=0&id=1d6d31fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d31fc",
  null
  
)

export default component.exports